import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=48f3d172&scoped=true&"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RouteBreadcrumb.vue?vue&type=style&index=0&id=48f3d172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3d172",
  null
  
)

component.options.__file = "RouteBreadcrumb.vue"
export default component.exports